import { LatexText } from '../../../components/ui/LatexText'
import { getFileUrl } from '../../../api/qb'

interface PassagePanelProps {
  content: string
  images?: string[] | null
  className?: string
}

/**
 * Renders a reading passage in a scrollable panel.
 * Used for reading comprehension, cloze, grammar fill, etc.
 */
export function PassagePanel({ content, images, className = '' }: PassagePanelProps) {
  return (
    <div
      className={`rounded-lg border border-blue-100 bg-blue-50/30 overflow-y-auto max-h-[50vh] ${className}`}
    >
      <div className="sticky top-0 z-10 bg-blue-50/80 backdrop-blur-sm px-4 py-2 border-b border-blue-100">
        <span className="text-xs font-semibold text-blue-700">📖 阅读文章</span>
      </div>
      <div className="p-4 text-sm text-slate-800 leading-relaxed whitespace-pre-wrap">
        <LatexText>{content}</LatexText>
      </div>
      {images && images.length > 0 && (
        <div className="px-4 pb-4 flex flex-wrap gap-2">
          {images.map((img, idx) => (
            <img
              key={idx}
              src={getFileUrl(img)}
              alt={`passage-img-${idx}`}
              className="max-h-48 rounded border border-slate-200 object-contain"
            />
          ))}
        </div>
      )}
    </div>
  )
}
